module.exports = __webpack_public_path__ + "img/5.4c05ee1f.png";